import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IAuthState, ILoginSchema, IRequestFailed, ISignUpForm } from "./types";
import { RequestStatus } from "@app/constants";

const initialState: IAuthState = {
  login: {},
  signUp: {}, 
  forgotPassword: {}, 
  resetPassword: {},
  verifyOtp:{}
};

const slice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    resetLoginState: () => initialState,
    login(state, action: PayloadAction<ILoginSchema>) {
      state.login.status = RequestStatus.RUNNING;
    },
    loginSuccess(state, action) {
      state.login.status = RequestStatus.SUCCESS;
      state.login.data = action.payload;
    },
    loginFailed(state, action: PayloadAction<IRequestFailed>) {
      state.login.status = RequestStatus.ERROR;
      state.login.error = action.payload;
    },
    verifyOtp(state, action: PayloadAction<ILoginSchema>) {
      state.verifyOtp.status = RequestStatus.RUNNING;
    },
    verifyOtpSuccess(state, action) {
      state.verifyOtp.status = RequestStatus.SUCCESS;
      state.verifyOtp.data = action.payload;
    },
    verifyOtpFailed(state, action: PayloadAction<IRequestFailed>) {
      state.verifyOtp.status = RequestStatus.ERROR;
      state.verifyOtp.error = action.payload;
    },
    signUp(state, action: PayloadAction<ISignUpForm>) {
      state.signUp.status = RequestStatus.RUNNING;
    },
    signUpSuccess(state, action) {
      state.signUp.status = RequestStatus.SUCCESS;
      state.signUp.data = action.payload;
    },
    signUpFailed(state, action: PayloadAction<IRequestFailed>) {
      state.signUp.status = RequestStatus.ERROR;
      state.signUp.error = action.payload;
    }, 
     forgotPassword(state, action: PayloadAction<any>) {
      state.forgotPassword.status = RequestStatus.RUNNING;
    },
    forgotPasswordSuccess(state, action) {
      state.forgotPassword.status = RequestStatus.SUCCESS;
      state.forgotPassword.data = action.payload;
    },
    forgotPasswordFailed(state, action: PayloadAction<IRequestFailed>) {
      state.forgotPassword.status = RequestStatus.ERROR;
      state.forgotPassword.error = action.payload;
    }, 
    resetPassword(state, action: PayloadAction<any>) {
      state.resetPassword.status = RequestStatus.RUNNING;
    },
    resetPasswordSuccess(state, action) {
      state.resetPassword.status = RequestStatus.SUCCESS;
      state.resetPassword.data = action.payload;
    },
    resetPasswordFailed(state, action: PayloadAction<IRequestFailed>) {
      state.resetPassword.status = RequestStatus.ERROR;
      state.resetPassword.error = action.payload;
    },
    logout() {
      //
    },
  },
});

export default slice.reducer;
export const {
  login,
  loginSuccess,
  loginFailed,
  signUp,
  signUpSuccess,
  signUpFailed, 
  forgotPasswordSuccess,
  forgotPasswordFailed,
  forgotPassword, 
  resetPassword, 
  resetPasswordSuccess, 
  resetPasswordFailed,
  logout,
  verifyOtp,
  verifyOtpFailed,
  verifyOtpSuccess,
  resetLoginState
} = slice.actions;
